import styled from '@emotion/styled/macro';

import { Line } from '../UI/Line/Line';

export const SimplePageLine = styled(Line)`
  margin-bottom: 1.5rem;
`;
